import { createStore } from 'vuex'
import dealer from './dealer'
import filter from './filter'

const state = () => ({
  brand: window.app.dealersearch_list.brand,
  initialized: false,
  errors: []
})

const getters = {}

const mutations = {
  setBrand (state, payload) {
    state.brand = payload
  },
  setInitialized (state, payload) {
    state.initialized = payload
  },
  setErrors (state, payload) {
    state.errors.push(payload)
  }
}

const actions = {
  init ({ dispatch, commit }) {
    Promise.all([
      dispatch('filter/get'),
      dispatch('dealer/get')
    ]).then(() => {
      // commit('filter/setCountry', '')
      commit('setInitialized', true)
    })
  },
  filter ({ dispatch, commit }) {
    commit('dealer/resetCurrentPage')
    dispatch('pushState')
    Promise.all([
      dispatch('dealer/get')
    ])
  },
  pushState ({ state }) {
    const url = new URL(window.location.href)
    if (state.brand !== 'default') {
      url.searchParams.set('brand', state.brand)
    } else {
      url.searchParams.delete('brand')
    }

    url.searchParams.delete('location-name')
    url.searchParams.delete('lat')
    url.searchParams.delete('lng')
    url.searchParams.delete('dealername')
    url.searchParams.delete('latitudeA')
    url.searchParams.delete('longitudeA')
    url.searchParams.delete('latitudeB')
    url.searchParams.delete('longitudeB')
    if (state.filter.location && state.filter.latitude && state.filter.longitude) {
      url.searchParams.set('location-name', state.filter.location)
      url.searchParams.set('lat', state.filter.latitude)
      url.searchParams.set('lng', state.filter.longitude)
    } else if (state.filter.dealername) {
      url.searchParams.set('dealername', state.filter.dealername)
    } else if (state.filter.swLatitude && state.filter.swLongitude && state.filter.neLatitude && state.filter.neLongitude) {
      url.searchParams.set('latitudeA', state.filter.swLatitude)
      url.searchParams.set('longitudeA', state.filter.swLongitude)
      url.searchParams.set('latitudeB', state.filter.neLatitude)
      url.searchParams.set('longitudeB', state.filter.neLongitude)
    }
    if (state.filter.services.length) {
      url.searchParams.set('services', state.filter.services.toString())
    } else {
      url.searchParams.delete('services')
    }
    if (state.filter.divisions.length) {
      url.searchParams.set('divisions', state.filter.divisions.toString())
    } else {
      url.searchParams.delete('divisions')
    }
    if (state.filter.models.length) {
      url.searchParams.set('models', state.filter.models.join(';'))
    } else {
      url.searchParams.delete('models')
    }
    if (state.filter.country) {
      url.searchParams.set('country', state.filter.country)
    } else {
      url.searchParams.delete('country')
    }
    if (state.filter.model) {
      url.searchParams.set('vehicle-model', state.filter.model)
    } else {
      url.searchParams.delete('vehicle-model')
    }
    if (state.filter.layouts.length) {
      url.searchParams.set('vehicle-layout', state.filter.layouts.toString())
    } else {
      url.searchParams.delete('vehicle-layout')
    }
    window.history.pushState({}, '', url)
  },
  loadMore ({ commit, dispatch }) {
    commit('dealer/increaseCurrentPage')
    Promise.all([
      dispatch('dealer/get')
    ])
  }
}

const modules = {
  dealer,
  filter
}

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules
})
